/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ClickIds interface.
 */
export function instanceOfClickIds(_value) {
    return true;
}
export function ClickIdsFromJSON(json) {
    return ClickIdsFromJSONTyped(json, false);
}
export function ClickIdsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fbclid': json['fbclid'] == null ? undefined : json['fbclid'],
        'gclid': json['gclid'] == null ? undefined : json['gclid'],
        'ttclid': json['ttclid'] == null ? undefined : json['ttclid'],
    };
}
export function ClickIdsToJSON(json) {
    return ClickIdsToJSONTyped(json, false);
}
export function ClickIdsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fbclid': value['fbclid'],
        'gclid': value['gclid'],
        'ttclid': value['ttclid'],
    };
}
